"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _Container = _interopRequireDefault(require("../Container"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Prompt =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Prompt, _PureComponent);

  function Prompt(props) {
    var _this;

    _classCallCheck(this, Prompt);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Prompt).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "checkBeforeClose", function (e) {
      var _this$props = _this.props,
          when = _this$props.when,
          message = _this$props.message;

      if (when) {
        e.returnValue = message; // REQUIRED

        (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
        return message;
      }

      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPrompt", function (nextLocation) {
      var _this$props2 = _this.props,
          when = _this$props2.when,
          location = _this$props2.location;

      if (!when) {
        // navigate if no need to prompt
        return true;
      }

      if (location.pathname === nextLocation.pathname) {
        // ignore if current pathname and target location pathname is the same
        return false;
      }

      _this.setState({
        visible: true,
        nextLocation: nextLocation
      }, function () {
        return false;
      });

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnCancel", function () {
      _this.setState({
        visible: false,
        nextLocation: null
      }, function () {
        var onClose = _this.props.onClose;

        if (onClose) {
          onClose();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnConfirm", function () {
      var nextLocation = _this.state.nextLocation;

      if (nextLocation) {
        // remove fixed scroll class from body when navigate to other page
        document.body.classList.remove(_Modal.default.fixedScrollClassName);

        _this.forceNavigate(nextLocation.pathname);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Prompt.className];
      (0, _lib.addClassByPropName)(names, _this.props);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var children = _this.props.children;
      var nextLocation = _this.state.nextLocation;
      var to;

      if (nextLocation) {
        // split string to get paths array
        var pathsArr = nextLocation.pathname.split('/').filter(function (i) {
          return i;
        }); // get last element ( the target location ) and capitalize using regex

        to = pathsArr[pathsArr.length - 1].replace(/^\w/, function (c) {
          return c.toUpperCase();
        });
      }

      return (0, _lib.getRenderProps)(children, {
        onConfirm: _this.handleOnConfirm,
        onCancel: _this.handleOnCancel,
        navigate: _this.navigate,
        forceNavigate: _this.forceNavigate,
        unblock: _this.handleUnblock,
        to: to
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnblock", function () {
      if (_this.unblock) {
        _this.unblock();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "navigate", function (url) {
      if (url && (0, _lib.isString)(url)) {
        // external url fallback
        if (url.includes('http')) {
          window.location.href = url;
        } else {
          var history = _this.props.history;
          history.push(url);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "forceNavigate", function (url) {
      if (url && (0, _lib.isString)(url)) {
        _this.handleUnblock();

        _this.navigate(url);
      }
    });

    var visible = props.visible;
    _this.state = {
      prevProps: {
        visible: visible
      },
      visible: visible,
      nextLocation: null
    };
    return _this;
  }

  _createClass(Prompt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var history = this.props.history;
      window.addEventListener('beforeunload', this.checkBeforeClose, false);
      this.unblock = history.block(function (nextLocation) {
        return _this2.handleOnPrompt(nextLocation);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.checkBeforeClose, false);
      this.handleUnblock();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          as = _this$props3.as,
          basic = _this$props3.basic,
          children = _this$props3.children,
          match = _this$props3.match,
          location = _this$props3.location,
          history = _this$props3.history,
          when = _this$props3.when,
          size = _this$props3.size,
          propsVisible = _this$props3.visible,
          onClose = _this$props3.onClose,
          onConfirm = _this$props3.onConfirm,
          onCancel = _this$props3.onCancel,
          rest = _objectWithoutProperties(_this$props3, ["as", "basic", "children", "match", "location", "history", "when", "size", "visible", "onClose", "onConfirm", "onCancel"]);

      var visible = this.state.visible;
      var classNames = this.classNames();

      if (basic) {
        return this.renderContent();
      }

      return _react.default.createElement(_Modal.default, _extends({}, rest, {
        as: as,
        visible: visible,
        className: classNames,
        onClose: this.handleOnCancel,
        size: size
      }), this.renderContent());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var visible = props.visible;
      return {
        // Store the previous props in state
        prevProps: {
          visible: visible
        },
        visible: prevProps.visible !== visible ? visible : state.visible
      };
    }
  }]);

  return Prompt;
}(_react.PureComponent);

_defineProperty(Prompt, "className", 'MHub-Prompt');

_defineProperty(Prompt, "displayName", 'Prompt');

_defineProperty(Prompt, "propTypes", {
  as: _common.customPropTypes.as,
  basic: _propTypes.default.bool,
  children: _common.customPropTypes.render.isRequired,
  match: _propTypes.default.shape({}).isRequired,
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  }).isRequired,
  history: _propTypes.default.shape({
    block: _propTypes.default.func
  }).isRequired,
  visible: _propTypes.default.bool,
  when: _propTypes.default.bool,
  size: _propTypes.default.string,
  message: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onConfirm: _propTypes.default.func,
  onCancel: _propTypes.default.func
});

_defineProperty(Prompt, "defaultProps", {
  as: _Container.default,
  basic: false,
  visible: false,
  when: false,
  size: 'small',
  message: 'You have unsaved changes. Do you still want to leave?',
  onClose: null,
  onConfirm: null,
  onCancel: null
});

var _default = (0, _reactRouterDom.withRouter)(Prompt);

exports.default = _default;